export default class HeroHandler {
    constructor() {
        const elements = document.querySelectorAll('.w-b-hero');

        elements.forEach((element) => {
            const video = element.querySelector('video');
            if (!video) return;

            let isPlayed = false;
            let isLoaded = false;
            const endedCallback = () => {
                isPlayed = true;
                video.classList.add('w-is-ended');
            };
            video.addEventListener('ended', endedCallback);
            video.addEventListener('loadeddata', () => {
                if (video.readyState >= 3) {
                    isLoaded = true;
                }
            });
            setTimeout(function () {
                if (!isLoaded && !isPlayed) {
                    video.classList.add('w-is-ended');
                    isPlayed = true;
                    video.removeEventListener('ended', endedCallback);
                }
            }, 2500);
        });
    }
}
